import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, XCircle } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ConfirmActionPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const action = searchParams.get("action");
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("");

  const handleConfirm = async () => {
    setStatus("loading");
    try {
      if (action === "delete_master") {
        const res = await api.post("/company-users/confirm-delete-master", { token });
        setMessage(res.data.message);
        setStatus("success");
        toast.success("Ação confirmada com sucesso");
      } else {
        setStatus("error");
        setMessage("Ação desconhecida");
      }
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.detail || "Erro ao confirmar");
      toast.error(err.response?.data?.detail || "Erro ao confirmar ação");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md space-y-6 text-center animate-fade-in">
        <div className="flex items-center justify-center gap-3 mb-4">
          <img src="/logo-kredz-dark.png" alt="Kredz" className="h-14 w-auto" />
        </div>

        {status === "pending" && (
          <>
            <h2 className="text-2xl font-bold">Confirmar Ação</h2>
            <p className="text-muted-foreground">
              {action === "delete_master" ? "Você está prestes a confirmar a remoção do seu acesso master. Esta ação não pode ser desfeita." : "Ação pendente de confirmação."}
            </p>
            <div className="flex gap-3 justify-center">
              <Button onClick={handleConfirm} className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8">
                Confirmar
              </Button>
              <Button variant="outline" onClick={() => navigate("/login")} className="border-white/10">
                Cancelar
              </Button>
            </div>
          </>
        )}

        {status === "loading" && <div className="loading-spinner w-8 h-8 mx-auto" />}

        {status === "success" && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center mx-auto">
              <Check className="w-8 h-8 text-emerald-400" />
            </div>
            <h2 className="text-2xl font-bold">Confirmado!</h2>
            <p className="text-muted-foreground">{message}</p>
            <Button onClick={() => navigate("/login")} className="bg-blue-600 hover:bg-blue-700 text-white">Ir para Login</Button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mx-auto">
              <XCircle className="w-8 h-8 text-red-400" />
            </div>
            <h2 className="text-2xl font-bold">Erro</h2>
            <p className="text-muted-foreground">{message}</p>
            <Button variant="outline" onClick={() => navigate("/login")} className="border-white/10">Voltar</Button>
          </>
        )}
      </div>
    </div>
  );
}
